<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="headline">
                Oznacz jako sprzedana
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-text-field
                                ref="value"
                                v-model="form.value"
                                label="Wartość zamówienia"
                                type="number"
                                solo
                                class="wastemaster-input-elevation"
                                :rules="formRules.value"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-select
                                :items="admins"
                                v-model="form.responsiblePerson"
                                label="Partner"
                                item-value="id"
                                solo
                                class="wastemaster-input-elevation"
                                :rules="formRules.responsiblePerson"
                            >
                                <template v-slot:selection="data">
                                    {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                                </template>
                                <template v-slot:item="data">
                                    {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            color="orange lighten-1"
                            large
                        >Oznacz jako sprzedana&nbsp;
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "../services/api";

export default {
    name: 'ModalSoldSaleOffer',
    components: {},
    data: () => ({
        dialog: false,
        form: {
            responsiblePerson: null,
            value: null,
        },
        formRules: {
            responsiblePerson: [(value) => value !== null || 'Wybierz osobę odpowiedzialną za ofertę'],
            value: [(value) => value !== null || 'Wpisz wartość zamówienia'],
        },
        valid: false,
        admins: [],
    }),
    methods: {
        open() {
            this.dialog = true
            this.getAdminUsers();
        },
        onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            this.$parent.sellOffer(this.form.responsiblePerson, this.form.value);
            this.dialog = false;
        },
        async getAdminUsers() {
            api.get('/api/users?showAdmins=true')
                .then((response) => {
                    this.admins = response.data.items;
                    console.log(this.admins);
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się pobrać listy użytkowników.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
}
</script>

<style scoped></style>
